import HandsontableHelper from "@/helpers/settings/handsontable";

const ContextMenu = (instance) => {
  {
    return {
      items: {
        title: {
          name: "Menu:",
          renderer: HandsontableHelper.contextMenuTitleRenderer,
          disableSelection: true, // Prevent mouseoever from highlighting the item for selection
          isCommand: true // Prevent clicks from executing command and closing the menu
        },
        edit: {
          name: "<div class='flex'><i class='fas fa-edit text-orange-500 mr-1 mt-1'></i><div>Edit row</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: instance.onEditSamples
        },
        new: {
          name: "<div class='flex'><i class='fas fa-edit text-orange-500 mr-1 mt-1'></i><div>New row</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: instance.onNewSamples
        },        
        delete: {
          name: "<div class='flex'><i class='fas fa-trash-alt text-red-500 mr-1 mt-1'></i><div>Delete row(s)</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: instance.onDeleteSamples
        }
      }
    }
  };
};
export default ContextMenu;